import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/checkmark.svg'


const _withScopeId = n => (_pushScopeId("data-v-efb35430"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "plans",
  id: "plans"
}
const _hoisted_2 = {
  class: "title",
  delay: 100
}
const _hoisted_3 = { class: "plans-list" }
const _hoisted_4 = ["delay"]
const _hoisted_5 = { class: "plan__title" }
const _hoisted_6 = { class: "plan__subtitle" }
const _hoisted_7 = {
  key: 0,
  class: "gray-text per-month"
}
const _hoisted_8 = { class: "plan__description" }
const _hoisted_9 = { class: "plan__description-list" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "check mark"
}, null, -1))
const _hoisted_11 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_motion_slide_title_element = _resolveDirective("motion-slide-title-element")!
  const _directive_motion = _resolveDirective("motion")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("h1", _hoisted_2, [
      _createTextVNode(" Plans ")
    ])), [
      [_directive_motion_slide_title_element]
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.plans, (plan, index) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: plan.title,
          class: _normalizeClass(["plan", {'highlighted': plan.highlighted}]),
          initial: {
          opacity: 0,
          y: 10
        },
          visibleOnce: {
          opacity: 1,
          y: 0
        },
          delay: (index + 1) * 250
        }, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(plan.title), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(plan.subtitle), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["plan__price", {'gray-text': plan.isCustomPrice}])
          }, [
            _createTextVNode(_toDisplayString(plan.price), 1),
            (!plan.isCustomPrice)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "/mo"))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plan.description, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.text,
                  class: "list__item"
                }, [
                  _hoisted_10,
                  _createElementVNode("p", {
                    class: "list__item-text",
                    innerHTML: $setup.insertHighlightedText(item.highlightedText, item.text)
                  }, null, 8, _hoisted_11)
                ]))
              }), 128))
            ])
          ])
        ], 10, _hoisted_4)), [
          [_directive_motion]
        ])
      }), 128))
    ])
  ]))
}